const body = $('body');

if (body.length) {
  $(document).ready(() => {
    body.addClass('content-loaded');
  });
}
